import { env } from "@/env.mjs";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Primitive } from "zod/v3";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function sendGA4ServerEvent(
  eventName: string,
  params: Record<string, unknown> = {},
  {
    measurementId = env.GA4_MEASUREMENT_ID!,
    apiSecret = env.GA4_API_SECRET!,
    clientId = "server",
    sessionId = Date.now(),
  } = {},
) {
  const url =
    "https://www.google-analytics.com/mp/collect" +
    `?measurement_id=${measurementId}&api_secret=${apiSecret}`;

  const body = JSON.stringify({
    client_id: clientId,
    events: [
      {
        name: eventName,
        params: { session_id: String(sessionId), ...params },
      },
    ],
  });

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
  });

  if (!res.ok) {
    console.warn("GA4 MP error", res.status, await res.text());
  }
}

/**
 * Creates the full query part of the URL string including the initial ?.
 * @param obj
 */
export function createSearchParams(
  obj: Record<string, Primitive>,
): `?${string}` | "" {
  const strBuild: Array<string> = [];
  const objEntries = Object.entries(obj);

  objEntries.forEach(([key, val], i, arr) => {
    if (typeof val !== "undefined" && val !== null) {
      strBuild.push(`${key}=${String(val)}`);
    }
  });

  return strBuild.length > 0 ? `?${strBuild.join("&")}` : "";
}
